import {Tooltip} from "@progress/kendo-react-tooltip"
import {useDispatch} from "react-redux"
import {
    CustomPrice,
    setSelectedCustomPricingId,
    showManageCustomPricingModal,
} from "../../containers/CustomPrices/customPricesSlice"

const CPTestPackages = ({customPrice}: {customPrice: CustomPrice}) => {
    const dispatch = useDispatch()

    const editCustomPrice = (customPricingId: number) => {
        dispatch(showManageCustomPricingModal(true))
        dispatch(setSelectedCustomPricingId(customPricingId))
    }

    return (
        <div>
            {customPrice.pricingTestPackages.map(
                (pricingTestPackages, ind) =>
                    ind <= 3 && (
                        <Tooltip key={`dealer_item_${ind}`} openDelay={100} position="bottom" anchorElement="pointer">
                            <div className="text-overflow-wrap pt-2" title={pricingTestPackages}>
                                {pricingTestPackages}
                            </div>
                        </Tooltip>
                    ),
            )}

            <div className={`clip-text font-weight-bold ps-0 ${customPrice.active ? "pb-0" : "k-disabled"}`}>
                <span
                    style={{cursor: "pointer"}}
                    onClick={() => {
                        customPrice.active && editCustomPrice(customPrice.customPricingID)
                    }}
                >
                    ...
                </span>
            </div>
        </div>
    )
}

export default CPTestPackages
